const axios = require("axios");
import store from "../store/index";
import { apiEndpoints as ApiEndpoints } from "./apiEndpoints";
import Headers from "./headers";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";

const axiosConfig = {
  timeout: 20000,
  headers: {
    Accept: "application/json",
  },
};

const HTTP = axios.create(axiosConfig);

export default HTTP;

// separate instance for axios refreshtoken call
const refreshInstance = axios.create();
let anonymousUserDispatchCount = 0;
const anonymousUserDispatchCounterLimit = 2;

const refresh_token = async (headers, sourceUrl) => {
  try {
    let credentials = localStorage.userInfo
      ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
      : "";
    if (LocalStorageFunc.isLoggedIn()) {
      return await refreshInstance.post(
        ApiEndpoints.REFRESH_TOKEN,
        {
          userId: headers.userid,
          refreshToken: credentials?.refreshToken,
        },
        { headers: headers }
      );
    } else {
      return await refreshInstance.post(
        ApiEndpoints.REFRESH_TOKEN_ANONYMOUS,
        {
          userId: headers.userid,
          refreshToken: credentials?.refreshToken,
        },
        { headers: headers }
      );
    }
  } catch (e) {
    // error handling in case refreshtoken has expired
    if (e.response.status === 500 || e.response.status === 401) {
      if (anonymousUserDispatchCount < anonymousUserDispatchCounterLimit) {
        anonymousUserDispatchCount++;
        if (!sourceUrl.includes("loginhandler/anonymoususer")) {
          store.commit(keyMapsMutation.UPDATE_LOGGIN_STATE, {
            isLoggedIn: false,
          });
          store.dispatch(keyMapsAction.ANONYMOUS_USER_API);
        } else {
          store.commit(keyMapsMutation.UPDATE_LOGGIN_STATE, {
            isLoggedIn: false,
          });
          setTimeout(() => {
            store.dispatch(keyMapsAction.ANONYMOUS_USER_API);
          }, 5000);
        }
      }
    }
  }
};

let refreshing_token = null;

HTTP.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    if (
      error.response &&
      (error.response?.status == 401 || error.response?.statusCode == 401) &&
      !config._retry
    ) {
      config._retry = true;
      if (config.url.includes("/forgotpassword")) {
        store.commit(
          "Auth/updateLoginError",
          error?.response?.data?.errors?.[0]?.description
        );
      } else {
        try {
          refreshing_token = refreshing_token
            ? refreshing_token
            : refresh_token(Headers({ withRefreshToken: true }), config.url);
          let res = await refreshing_token;
          refreshing_token = null;
          // @todo remove later when credentials not required
          // if (res?.data?.credentials) {
          //   store.commit(
          //     "Auth/updateLocalStorageUserInfoCredential",
          //     res.data.credentials
          //   );
          //   config.headers = {
          //     ...config.headers,
          //     authtoken: res.data.credentials.accessToken,
          //   };

          //   if(!LocalStorageFunc.isLoggedIn()){
          //     config.headers = {
          //       ...config.headers,
          //       authtoken : res.data.credentials.accessKeyId,
          //       sessiontoken: res.data.credentials.sessiontoken,
          //     };
          //   }
          //   return HTTP(config);
          // }
          if (res?.data?.credentials) {
            store.commit("Auth/updateLocalStorageUserInfo", res.data);
            if (res?.data?.credentials?.accessToken) {
              if (config.headers["authToken"])
                delete config.headers["authToken"];
              config.headers["Authtoken"] = res.data.credentials.accessToken;
            } else {
              config.headers = {
                ...config.headers,
                sessiontoken: res.data.credentials.sessionToken,
              };
              if (config.headers["authToken"])
                delete config.headers["authToken"];
              config.headers["Authtoken"] = res.data.credentials.accessKeyId;
            }
            return HTTP(config);
          }
        } catch (err) {
          // store.commit(keyMapsMutation.UPDATE_LOGGIN_STATE, {
          //   isLoggedIn: false,
          // });
          return Promise.reject(err);
        }
      }
    } else if (error?.response?.data) {
      return error.response.data;
    }
    return Promise.reject(error);
  }
);
